import * as OFMSUI from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Field, useFormik, FormikProvider, ErrorMessage } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { DashboardServiceReport, LabelHeader, ModuleHeader, NumberValidation, SubmitButton, todayDate } from "../../utils/commonFunctions";
import { store } from "../../../App";
import ShowAlert from "../../alert";
import Swal from "sweetalert2/dist/sweetalert2.js";


const DirectDebitCredit = () => {
  const [bankNamesList, setbankNamesList] = useState([]);


  const validationSchema = Yup.object().shape({
    bankname: Yup.string().required("required"),
    date: Yup.string().required("required"),
    paymenttype: Yup.string().required("required"),
    amount: Yup.string().required("required"),
    remarks: Yup.string().required("required"),

  });
  const formik = useFormik({
    initialValues: {
      bankname: "",
      date: "",
      paymenttype: "",
      amount: "",
      remarks: ""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
        Swal.fire({
            text: "Are You Sure Want to Submit?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
          }).then((result) => {
            if (result.isConfirmed) {
              store.dispatch({ type: "SHOW_SPINNER" });
              let params = 
              { "brsBanknameaccountno":values.bankname,
                "brsBankdate":values.date,
                "brsAmount":parseFloat(values.amount),
                "brsTransaction_type":values.paymenttype,
                "brsRemarks":values.remarks,
              }
              HousingService.DirectCreditDebitInsertion(params).then((res) => {
                if (res.data.responseToken === "1") {
                  ShowAlert(res.data.responseMessage, "success").then(function (isConfirm) { if (isConfirm.value) { history.go(0); } });
                }
                else {
                  ShowAlert(res.data.responseMessage, "error")
                }
              }).catch((error) => {
                ShowAlert("Some error occcured", "error");
              }).finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
              });
            }
          });
    }
  });

  React.useEffect(() => {
    HousingService.fetchBank().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.banknameaccountno}> {item.banknameaccountno} </option>
            );
          }
        });
        setbankNamesList(options);
      }
    });
  }, []);






  return (
    <>
      <NavigationServicesHeader />
      <ModuleHeader title="Direct Debit/Credit" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <DashboardServiceReport title="Service" />
            <OFMSUI.Row className="mb-3">
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Date" /> <Field type="date" max={todayDate} name="date" className={formik.touched.date && formik.errors.date ? "form-control is-invalid" : "form-control"} />  <ErrorMessage name="date" component={"div"} className="text-error" /> </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Payment type" /> <Field component="select" name="paymenttype" className={formik.touched.paymenttype && formik.errors.paymenttype ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> 
              <option value="credit">Credit</option> 
              <option value="debit">Debit</option> 
              </Field> <ErrorMessage name="paymenttype" component={"div"} className="text-error" /> </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Bank" /> <Field component="select" name="bankname" className={formik.touched.bankname && formik.errors.bankname ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {bankNamesList} </Field> <ErrorMessage name="bankname" component={"div"} className="text-error" /> </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Amount" /> <Field type="text"  name="amount" className={formik.touched.amount && formik.errors.amount ? "form-control is-invalid" : "form-control"} onKeyPress={(e) => NumberValidation(e)} maxLength={15} />  <ErrorMessage name="amount" component={"div"} className="text-error" /> </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Remarks" /> <Field as="textarea"  name="remarks" className={formik.touched.remarks && formik.errors.remarks ? "form-control is-invalid" : "form-control"} />  <ErrorMessage name="remarks" component={"div"} className="text-error" /> </OFMSUI.Col>
            </OFMSUI.Row>
            <SubmitButton title="Submit" />





          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  )
}

export default DirectDebitCredit
